import { RootState } from "./store"

export const selectSeenChatJids = (state: RootState) => {
  return state.seenChats
}
